// import { TitleBar } from '@/services/Forms/Forms'
import { Checkbox_, Input_, Kotak, Select_, TitleBar } from '@/services/Forms/FormsSatu'
import { UploadOutlined } from '@ant-design/icons'
import { Checkbox, Form, Input, Select, Tabs } from 'antd'
import MainLayouts from 'layouts/MainLayouts'
import React, { useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import { Date_ } from 'services/Forms/Forms'
import { Button_, Switch_ } from 'services/Forms/FormsSatu'
import { msg } from 'services/Toastr/Notify/_Toastr'
import ChecklistPolaMakan from './ChecklistPolaMakan'
import FormHidanganSehari from 'pages/FormHidanganSehari/FormHidanganSehari'
import { HAPUS_IFUNDEFINE } from 'services'
import _Api from 'services/Api/_Api'
import moment from 'moment'
import dayjs from 'dayjs'

function RiwayatPolaMakan(pr) {

    const [frm] = Form.useForm()

    const [data, setdata] = useState([])
    const [agama, setagama] = useState()
    const [jeniskelamin, setjeniskelamin] = useState()
    const [pendidikan, setpendidikan] = useState()
    const [listDiet, setlistDiet] = useState([])

    const FORM_ID = 2
    const KONSELING_ID = pr.konseling_id

    const getCombo = () => {
        _Api.get("/get-combo-form?form_id=" + FORM_ID + "&konseling_id=" + KONSELING_ID).then(res => {
            // setcombo(res)
            var dt = res.data.combo
            var rc = res.data.record
            setdata(rc)
            setlistDiet(res.data.listdiet)


            frm.setFieldsValue(rc)

            var initfield = {}

            rc.map(gg => {
                if (gg.tipedata == "checkbox") {
                    initfield.centang = { ...initfield.centang, [gg.fiel_fk]: gg.value == 1 }
                } else
                    if (gg.tipedata == "textbox") {
                        initfield[gg.fiel_fk] = gg.value
                    } else
                        if (gg.tipedata == "int") {
                            initfield[gg.fiel_fk] = parseInt(gg.value)
                        } else
                            if (gg.tipedata == "date") {
                                initfield[gg.fiel_fk] = moment(gg.value)
                            } else
                                if (gg.tipedata == "multiple" && gg.value != undefined) {
                                    var vlll = gg.value.split(",")
                                    initfield[gg.fiel_fk] = vlll
                                }
            })
            // initfield.tanggal = moment()
            frm.setFieldsValue(initfield)
            console.log(initfield)

            const agama = dt.filter(x => x.kelompok_id == "2")
            setagama(agama)

            const jk = dt.filter(x => x.kelompok_id == "1")
            setjeniskelamin(jk)

            const pdd = dt.filter(x => x.kelompok_id == "3")
            setpendidikan(pdd)
        })
    }
    const simpanData = () => {
        // console.log(val)
        frm.validateFields().then(val => {
            var pure = HAPUS_IFUNDEFINE(val)
            // delete cek.centang
            const cheklist = HAPUS_IFUNDEFINE(val.centang)
            var obj = {
                konseling_id: KONSELING_ID,
                form_id: FORM_ID,
                // diet : ,
                data: { 
                    ...pure, 
                    ...cheklist, 
                    diet: pure.diet && pure.diet.length > 0 ? pure.diet.toString() : "",
                    diitsebelumnya: pure.diitsebelumnya && pure.diitsebelumnya.length > 0 ?  pure.diitsebelumnya.toString() :"",
                }
            }
            delete obj.data.centang
            _Api.post("simpan-form-konseling", obj).then(rs => {
                msg.auto(rs.data)
            })
        }).catch(err => {
            console.log(err)
            msg.error("Silahkan lengkapi data ")
        })
    }

    const hitungIMT = () => { 
        var bb = frm.getFieldValue("bb") ?? 0
        var tb = frm.getFieldValue("tb") ?? 0
        var imt = (bb / (tb * tb) * 10000).toFixed(2)
        frm.setFieldsValue({ "imt": imt })
    }

    useEffect(() => {
        getCombo()
        // frm.setFieldsValue({ "centang": { "jagung_1": true, } })
    }, [])

    const listRata2 = [
        { id: 1, label: "Rata-rata Sehari", name: "rata2sehari", sm: "2" },
        { id: 2, label: "Kalori", name: "kal", sm: "1" },
        { id: 3, label: "Protein", name: "protein", sm: "1", satuan: "gr" },
        { id: 4, label: "Karbo Hidrat", name: "karbohidrat", sm: "2", satuan: "gr" },
        { id: 5, label: "Kalsium", name: "kalsium", sm: "1", satuan: "gr" },
        { id: 6, label: "Zat Besi", name: "zatbesi", sm: "2", satuan: "gr" },
        { id: 7, label: "Vit. A", name: "vita", sm: "1", satuan: "gr" },
        { id: 8, label: "Vit. B1", name: "vitb1", sm: "1", satuan: "gr" },
        { id: 9, label: "Vit. C", name: "vitc", sm: "1", satuan: "gr" },
    ]

    const hitungUmur = () => {
        var tgl = frm.getFieldValue("tgllahir")
        var umur = dayjs().diff(tgl, 'year').toString()
        frm.setFieldsValue({ "umur": umur })
    }
    // <Col>  </Col>
    // <Col> </Col>
    // <Col>  </Col>
    // <Col>  </Col>
    // <Col>  </Col>
    // <Col>  </Col>


    return (
        <div>
            <div className='mb-2'>
                <TitleBar title="Formulir Riwayat Pola Makan/ Kebiasaan" />
            </div>
            <Form layout='vertical' form={frm}

                // initialValues={{
                //     centangya: true, // Single checkbox initial value
                //   }}
                onFinish={simpanData}>
                <Row>
                    <Input_ label="Instalasi" sm="3" name="instalasi_id" defaultValue="Instalasi Gizi"  />
                    {/* <Input_ label="Klinik" sm="3" name="klinik" /> */}
                    <Input_ label="RS" defaultValue="RSUD H. Moh. Ruslan" sm="4" />
                    <Date_ label="Tanggal Pengkajian" sm="3" name="tanggal" />
                </Row>
                
                <br />

                <Kotak label="KETERANGAN TENTANG MAKANAN">
                    <Select_ label="Diit Sebelumnya" sm="11" name="diitsebelumnya" val="jenisdiet" caption="jenisdiet" multiple option={listDiet} />
                    {/* <Input_ label="Diit Sebelumnya" sm="11" name="diitsebelumnya" /> */}
                    <Input_ label="Alergi terhadap makanan /pantangan/suka/tidak suka" sm="11" name="alergi" />
                    <Input_ label="Keterangan Lainnya" multiline sm="11" name="keteranganlain" />
                </Kotak>

                <ChecklistPolaMakan />

                {/* <Tabs defaultActiveKey="1" type='card'>
                    <Tabs.TabPane tab={<h4 className='px-4 b'>Pola Makanan</h4>} key="1">
                    </Tabs.TabPane>
                   

                </Tabs> */}

                <br />
                <Row>
                    {/* {
                        listRata2.map((a, j, i) => (
                            <Input_ label={a.label} sm={a.sm} name={a.name} addonAfter={a.satuan} />
                        ))
                    } */}
                    <Input_ name="sikappasienterhadapdiet" label="Sikap Pasien Terhadap Diet" multiline />
                    <Input_ name="anjuranbaikipkebiasaanmakan" label="Anjuran utuk memperbaiki kebiasaan nakanan/menjalankan diet" multiline />
                    <Date_ name="tanggaldiet" label="Tanggal" sm="3" />
                    <Input_ name="dietisen" label="Dietisen" sm="6" />
                    <Col className='bg-white' sm="3">
                        <div> Tanda Tangan </div>
                    </Col>
                    <div className='b'> Ket : Untuk pasien dengan diet khusus, RDA diisi dengan kebutuhan diitnya </div>
                </Row>



            </Form>
            {/* <FloatButton onClick={() => console.log('onClick')} /> */}
            <div className='fixed-bawah'>
                <Row>
                    <Button_ sm="2" icon={<UploadOutlined />} block title="Simpan" onClick={simpanData} />
                    {/* <Button_ sm="3" color="orange" icon={<UploadOutlined />} block title="Form Hidangan Sehari ( Recall 24 Jam )" /> */}
                    <Col></Col>
                </Row>
            </div>
        </div>
    )
}
export default RiwayatPolaMakan;

